module.exports = __webpack_public_path__ + "static/media/LetterIcon.d7db82e2.svg";